import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarminibus() {



  const cardData = {
"keyword": "Pune to Mahabaleshwar Mini Bus",

"headingDescription":
  "Aaradhya Travels offers reliable Pune to Mahabaleshwar Mini Bus service for family trips, corporate outings, school tours, destination weddings, sightseeing travel, and comfortable group journeys. Our fleet includes 14, 17, 20, 25, 32, and 35-seater mini buses equipped with air-conditioning, pushback seats, spacious interiors, and experienced drivers familiar with Pune to Mahabaleshwar ghat routes. We provide safe, comfortable, and punctual transportation with doorstep pickup from Pune city, railway stations, airport, hotels, and residential areas for smooth hill station group travel.",

"topPlaces": [
  {
    "title": "Mahabaleshwar Hill Station",
    "description":
      "Mahabaleshwar is one of Maharashtra’s most famous hill stations known for cool weather, green valleys, scenic viewpoints, and strawberry farms."
  },
  {
    "title": "Venna Lake",
    "description":
      "Venna Lake is a popular tourist attraction in Mahabaleshwar offering boating activities, horse riding, and lakeside family outings."
  },
  {
    "title": "Mapro Garden",
    "description":
      "Mapro Garden is a famous tourist spot near Mahabaleshwar known for strawberry products, food courts, gardens, and family entertainment."
  },
  {
    "title": "Arthur Seat Point",
    "description":
      "Arthur Seat Point is a scenic viewpoint in Mahabaleshwar offering panoramic valley views and dramatic Sahyadri mountain landscapes."
  },
  {
    "title": "Elephant Head Point",
    "description":
      "Elephant Head Point is a unique cliff viewpoint in Mahabaleshwar known for its naturally shaped rock formations and scenic beauty."
  },
  {
    "title": "Wilson Point",
    "description":
      "Wilson Point is the highest viewpoint in Mahabaleshwar famous for sunrise views and panoramic mountain scenery."
  },
  {
    "title": "Lingmala Waterfall",
    "description":
      "Lingmala Waterfall is a popular monsoon attraction near Mahabaleshwar surrounded by lush greenery and trekking trails."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is a beautiful hill station near Mahabaleshwar known for boarding schools, valleys, strawberry farms, and scenic viewpoints."
  },
  {
    "title": "Table Land Panchgani",
    "description":
      "Table Land is a large volcanic plateau in Panchgani offering horse rides, scenic views, and outdoor activities for tourists."
  },
  {
    "title": "Parsi Point",
    "description":
      "Parsi Point near Panchgani is a famous viewpoint overlooking Krishna Valley and Dhom Dam."
  },
  {
    "title": "Wai",
    "description":
      "Wai is a historic town on the Pune–Mahabaleshwar route known for temples, river ghats, and film shooting locations."
  },
  {
    "title": "Panchganga Temple",
    "description":
      "Panchganga Temple in Mahabaleshwar is a sacred religious site associated with the origin of five rivers."
  },
  {
    "title": "Old Mahabaleshwar Temple",
    "description":
      "Old Mahabaleshwar Temple is an ancient Shiva temple visited by devotees and tourists during Mahabaleshwar trips."
  },
  {
    "title": "Kaas Plateau",
    "description":
      "Kaas Plateau near Mahabaleshwar is a UNESCO-recognized flower valley famous for seasonal wildflower blooms."
  },
  {
    "title": "Pratapgad Fort",
    "description":
      "Pratapgad Fort is a historic Maratha fort near Mahabaleshwar known for its history, trekking routes, and panoramic hill views."
  },
  {
    "title": "Katraj Tunnel Route",
    "description":
      "Katraj Tunnel route is part of the Pune to Mahabaleshwar highway journey offering smooth connectivity towards Satara and hill stations."
  },
  {
    "title": "Satara",
    "description":
      "Satara is an important city on the Pune–Mahabaleshwar route known for historical landmarks and highway connectivity."
  },
  {
    "title": "NH48 Highway",
    "description":
      "NH48 Highway provides smooth road connectivity between Pune and Mahabaleshwar, widely used for comfortable mini bus travel."
  },
  {
    "title": "Strawberry Farms",
    "description":
      "Mahabaleshwar is famous for fresh strawberry farms where tourists enjoy fruit picking and local farm experiences."
  },
  {
    "title": "Scenic Sahyadri Ghat Route",
    "description":
      "The Pune to Mahabaleshwar route passes through beautiful Sahyadri mountain roads, valleys, waterfalls, and lush green landscapes."
  }
],



services: [
  {
    name: "Pune to Mahabaleshwar Mini Bus Hire",
    description: "Pune to Mahabaleshwar mini bus hire service provides comfortable transportation for hill station vacations, sightseeing tours, family outings, and weekend trips. Spacious seating and smooth highway travel ensure pleasant journeys suitable for tourists and group travelers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar mini bus reservations."
  },
  {
    name: "Mahabaleshwar Tour Bus Pune",
    description: "Mahabaleshwar tour bus Pune service offers reliable transportation for sightseeing tours, holiday vacations, educational trips, and family travel to the popular hill station destination. Spacious buses ensure smooth travel suitable for local and outstation tourist requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar tour bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar AC Bus Rental",
    description: "Pune to Mahabaleshwar AC bus rental service provides premium air-conditioned transportation for family vacations, group travel, sightseeing tours, and holiday journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions and long-distance journeys. Professional chauffeurs ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient AC Mahabaleshwar bus reservations."
  },
  {
    name: "Non AC Mahabaleshwar Bus Pune",
    description: "Non AC Mahabaleshwar bus Pune service offers affordable transportation for hill station travel, educational tours, family vacations, and sightseeing trips. Spacious buses ensure comfortable highway travel suitable for budget-friendly travel requirements and group journeys. Professional drivers ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient non AC Mahabaleshwar bus reservations."
  },
  {
    name: "Hill Station Trip Bus Pune",
    description: "Hill station trip bus Pune service provides dependable transportation for Mahabaleshwar, Panchgani, and nearby hill station tours with comfortable seating and spacious interiors. Smooth highway travel ensures pleasant journeys suitable for tourists, families, and group travelers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the hill station route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient hill station trip bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar Group Travel Bus",
    description: "Pune to Mahabaleshwar group travel bus service offers spacious transportation for educational tours, office outings, family vacations, and tourist group travel. Comfortable buses ensure smooth highway travel suitable for medium and large passenger groups. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the Mahabaleshwar journey. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Mahabaleshwar Sightseeing Bus Pune",
    description: "Mahabaleshwar sightseeing bus Pune service provides comfortable transportation for tourists planning visits to scenic viewpoints, strawberry farms, lakes, and famous attractions in Mahabaleshwar. Spacious seating and smooth travel ensure pleasant sightseeing experiences suitable for family and group tours. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient sightseeing bus reservations."
  },
  {
    name: "17 Seater Mahabaleshwar Bus Pune",
    description: "17 seater Mahabaleshwar bus Pune service provides spacious transportation for family vacations, educational tours, office outings, and hill station travel requirements. Comfortable seating and luggage space ensure smooth journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater Mahabaleshwar bus reservations."
  },
  {
    name: "25 Seater Mahabaleshwar Bus Pune",
    description: "25 seater Mahabaleshwar bus Pune service offers reliable transportation for large tourist groups, family outings, educational tours, and corporate travel to Mahabaleshwar. Spacious interiors and comfortable seating ensure smooth highway journeys suitable for long-distance group travel. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient 25 seater Mahabaleshwar bus reservations."
  },
  {
    name: "Luxury Mini Bus Pune to Mahabaleshwar",
    description: "Luxury mini bus Pune to Mahabaleshwar service provides premium transportation with elegant interiors and spacious seating for family vacations, executive travel, and hill station tours. Smooth highway performance ensures pleasant journeys suitable for luxury group travel and tourist outings. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, luxury hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury Mahabaleshwar mini bus reservations."
  },
  {
    name: "Budget Bus Pune to Mahabaleshwar",
    description: "Budget bus Pune to Mahabaleshwar service offers economical transportation for family outings, sightseeing tours, educational trips, and group travel requirements. Spacious buses ensure comfortable travel suitable for budget-friendly hill station journeys and tourist travel. Professional drivers ensure reliable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient budget Mahabaleshwar bus reservations."
  },
  {
    name: "Family Trip Bus Mahabaleshwar Pune",
    description: "Family trip bus Mahabaleshwar Pune service provides comfortable transportation for holiday vacations, sightseeing journeys, and group travel with relatives and family members. Spacious seating and luggage space ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Corporate Outing Mahabaleshwar Bus Pune",
    description: "Corporate outing Mahabaleshwar bus Pune service offers professional transportation for office trips, employee outings, conferences, and business travel requirements. Spacious buses ensure smooth travel suitable for office teams and corporate passenger groups. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, hotels, commercial hubs, and business locations across Pune. Flexible booking options allow convenient corporate outing bus reservations."
  },
  {
    name: "Weekend Trip Bus Pune Mahabaleshwar",
    description: "Weekend trip bus Pune Mahabaleshwar service provides dependable transportation for short holiday vacations, sightseeing tours, and family outings to the popular hill station destination. Spacious seating and smooth travel ensure pleasant journeys suitable for weekend travelers and tourist groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient weekend trip bus reservations."
  },
  {
    name: "Pune to Panchgani Mahabaleshwar Bus",
    description: "Pune to Panchgani Mahabaleshwar bus service offers reliable transportation for combined hill station sightseeing tours, family vacations, and tourist travel requirements. Spacious buses ensure comfortable highway journeys suitable for local and outstation group travel. Professional drivers ensure safe transportation and dependable pickup services throughout the Panchgani and Mahabaleshwar route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient Panchgani Mahabaleshwar bus reservations."
  },
  {
    name: "Mahabaleshwar Outstation Bus Hire Pune",
    description: "Mahabaleshwar outstation bus hire Pune service provides spacious long-distance transportation for hill station vacations, tourist travel, family outings, and sightseeing journeys. Comfortable buses ensure smooth travel suitable for local and outstation tourist requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus hire reservations."
  },
  {
    name: "Mahabaleshwar Tour Package Bus Pune",
    description: "Mahabaleshwar tour package bus Pune service offers dependable transportation for complete sightseeing tours, tourist travel plans, family vacations, and holiday group journeys. Spacious buses ensure comfortable travel suitable for package tours and outstation travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Mahabaleshwar package bus reservations."
  },
  {
    name: "Private Mahabaleshwar Bus Pune",
    description: "Private Mahabaleshwar bus Pune service provides exclusive transportation for family vacations, sightseeing tours, tourist travel, and personalized hill station journeys. Spacious buses ensure smooth and private travel suitable for families, tourists, and group travelers. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient private Mahabaleshwar bus reservations."
  },
  {
    name: "Door Pickup Mahabaleshwar Bus Pune",
    description: "Door pickup Mahabaleshwar bus Pune service offers convenient transportation with home pickup facilities for hill station vacations, sightseeing tours, and family travel requirements. Comfortable buses ensure smooth highway travel suitable for local and outstation tourist journeys. Professional drivers ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available directly from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient door pickup bus reservations."
  },
  {
    name: "Mahabaleshwar Return Bus Pune",
    description: "Mahabaleshwar return bus Pune service provides comfortable round-trip transportation for sightseeing tours, family vacations, tourist travel, and group journeys from Pune. Spacious seating and smooth travel ensure pleasant return journeys suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient Mahabaleshwar return bus reservations."
  },
  {
    name: "Scenic Tour Bus Pune to Mahabaleshwar",
    description: "Scenic tour bus Pune to Mahabaleshwar service offers enjoyable transportation through beautiful hill station routes, valleys, and ghat roads for tourists and family travelers. Spacious seating and panoramic travel experiences ensure memorable journeys suitable for sightseeing and holiday vacations. Professional drivers ensure safe transportation and dependable pickup services throughout the scenic route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient scenic tour bus reservations."
  },
  {
    name: "AC Luxury Bus Mahabaleshwar Pune",
    description: "AC luxury bus Mahabaleshwar Pune service provides premium air-conditioned transportation with elegant interiors for executive travel, family vacations, and sightseeing tours. Comfortable seating and smooth highway performance ensure pleasant journeys suitable for luxury tourist travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, luxury hotels, offices, and airports across Pune. Flexible booking options allow convenient AC luxury bus reservations."
  },
  {
    name: "Group Tour Vehicle Mahabaleshwar Pune",
    description: "Group tour vehicle Mahabaleshwar Pune service offers spacious transportation for educational tours, office outings, family trips, and tourist group travel to the hill station destination. Comfortable buses ensure smooth highway journeys suitable for medium and large passenger groups. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group tour vehicle reservations."
  },
  {
    name: "Affordable Mahabaleshwar Bus Rental",
    description: "Affordable Mahabaleshwar bus rental service provides economical transportation for family vacations, educational tours, sightseeing trips, and tourist travel requirements. Spacious buses ensure comfortable journeys suitable for budget-friendly outstation travel and group tours. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient affordable Mahabaleshwar bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar Shuttle Bus",
    description: "Pune to Mahabaleshwar shuttle bus service offers reliable transportation for regular tourist travel, family vacations, sightseeing tours, and group journeys between Pune and Mahabaleshwar. Spacious buses ensure smooth travel suitable for local and outstation passenger requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar shuttle bus reservations."
  }
],

tableData: [
  ["Pune to Mahabaleshwar Mini Bus Hire", "Mahabaleshwar Tour Bus Pune"],
  ["Pune to Mahabaleshwar AC Bus Rental", "Non AC Mahabaleshwar Bus Pune"],
  ["Hill Station Trip Bus Pune", "Pune to Mahabaleshwar Group Travel Bus"],
  ["Mahabaleshwar Sightseeing Bus Pune", "17 Seater Mahabaleshwar Bus Pune"],
  ["25 Seater Mahabaleshwar Bus Pune", "Luxury Mini Bus Pune to Mahabaleshwar"],
  ["Budget Bus Pune to Mahabaleshwar", "Family Trip Bus Mahabaleshwar Pune"],
  ["Corporate Outing Mahabaleshwar Bus Pune", "Weekend Trip Bus Pune Mahabaleshwar"],
  ["Pune to Panchgani Mahabaleshwar Bus", "Mahabaleshwar Outstation Bus Hire Pune"],
  ["Mahabaleshwar Tour Package Bus Pune", "Private Mahabaleshwar Bus Pune"],
  ["Door Pickup Mahabaleshwar Bus Pune", "Mahabaleshwar Return Bus Pune"],
  ["Scenic Tour Bus Pune to Mahabaleshwar", "AC Luxury Bus Mahabaleshwar Pune"],
  ["Group Tour Vehicle Mahabaleshwar Pune", "Affordable Mahabaleshwar Bus Rental"],
  ["Pune to Mahabaleshwar Shuttle Bus", "Pune to Mahabaleshwar Mini Bus Hire"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mahabaleshwar Mini Bus Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Mahabaleshwar mini bus service with comfortable vehicles, professional drivers, and smooth travel arrangements for family vacations, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Mahabaleshwar Mini Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Mahabaleshwar mini bus rental packages with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking for Mahabaleshwar Travel",
        WhyChoosedescription: "Our Pune to Mahabaleshwar mini bus service operates 24 hours for weekend trips, sightseeing tours, family vacations, corporate outings, and outstation travel requirements."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable hill station travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Mahabaleshwar Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day Mahabaleshwar sightseeing trips, weekend getaways, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Mini Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses suitable for families, tourist groups, corporate teams, and holiday travelers."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Ghat Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Mahabaleshwar ghat roads and ensure safe driving, smooth journeys, and comfortable outstation travel experiences."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Mahabaleshwar mini bus service?", answer: "Pune to Mahabaleshwar mini bus service provides comfortable group transportation for family vacations, sightseeing tours, and outstation travel." },
    { question: "Is Pune to Mahabaleshwar mini bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus booking service from Pune to Mahabaleshwar." },
    { question: "Which mini bus seating options are available for Mahabaleshwar travel?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, and 25 seater mini buses for group travel requirements." },
    { question: "Can I book mini bus for one-day Mahabaleshwar trip?", answer: "Yes, customers can book one-day as well as multi-day Mahabaleshwar mini bus tour packages." },
    { question: "Do you provide AC and Non-AC mini buses for Mahabaleshwar travel?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly hill station travel." },
    { question: "Can I book Pune to Mahabaleshwar mini bus online?", answer: "Yes, customers can easily book mini bus service online or through phone booking." },
    { question: "Do you provide mini buses for family and corporate group tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for families, tourists, and corporate group travel." },
    { question: "Are Pune to Mahabaleshwar mini bus charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Mahabaleshwar mini bus service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Ajit Deshpande",
    feedback:
      "The Pune to Mahabaleshwar trip with Aaradhya Travels in a mini bus was very refreshing. The drive through the hills was comfortable, and the group enjoyed the scenic journey without any travel fatigue.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Aaradhya Travels arranged a mini bus for our Pune to Mahabaleshwar outing, and the experience was excellent. The ride was smooth on ghat roads, and everyone appreciated the comfort throughout the journey.",
    rating: 5
  }
];








  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Mini Bus",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-mahabaleshwar-mini-bus.jpg",
  "description": "Book Pune to Mahabaleshwar Mini Bus with Aaradhya Travels for comfortable hill station group travel. Available AC and Non-AC mini buses including 17 and 25 seater options for family trips, sightseeing, corporate outings, and weekend tours from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5412"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-mahabaleshwar-mini-bus"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Mahabaleshwar Mini Bus | AC & Non-AC Hill Station Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune to Mahabaleshwar Mini Bus with Aaradhya Travels. Affordable AC and Non-AC mini bus options including 17 and 25 seater vehicles for hill station trips, group travel, family outings, and sightseeing tours from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Mahabaleshwar mini bus hire, Mahabaleshwar tour bus Pune, Pune to Mahabaleshwar AC bus rental, Non AC Mahabaleshwar bus Pune, Hill station trip bus Pune, Pune to Mahabaleshwar group travel bus, Mahabaleshwar sightseeing bus Pune, 17 seater Mahabaleshwar bus Pune, 25 seater Mahabaleshwar bus Pune, Luxury mini bus Pune to Mahabaleshwar, Budget"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarminibus;